function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback } from 'react';
import FileUpload from '@rd-web-markets/shared/dist/util/FileUpload';
import { useFileUpload } from '@rd-web-markets/shared/dist/hooks';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { useTranslation } from 'react-i18next';
import generalService from '@rd-web-markets/shared/dist/services/claim_groups/general_service';
const ElsterFileSection = _ref => {
  let {
    elsterId,
    elster,
    setElster
  } = _ref;
  const {
    t
  } = useTranslation();
  const uploadFile = useErrorHandling(useCallback(async formData => {
    formData.append('claim_group', JSON.stringify({
      id: elsterId
    }));
    const response = await generalService.postFormData(elsterId, 'elster_actions', 'elster_action_attachments', formData);
    const currentElster = elster.elster_actions.find(elster => elster.id === elsterId);
    delete currentElster.file;
    currentElster.file = _objectSpread({}, response.file);
    setElster(_objectSpread({}, elster));
  }, []));
  const [file, isFileUploadLoading, setFile] = useFileUpload(uploadFile);
  return /*#__PURE__*/React.createElement(FileUpload, {
    loading: isFileUploadLoading,
    title: t('upload_document'),
    file: file,
    onSelectFile: setFile,
    classesForDefaultBody: "d-flex"
  });
};
export default ElsterFileSection;